<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('escorters')" :icon="'grid'" />
            </div>
            <div class="col-sm-12 col-md-6 breadcrumb-side-button"
                v-if="this.$can('create_escorters')">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                    <button type="button" class="btn btn-primary btn-with-shadow" data-toggle="modal"
                        @click="openAddEditModal">
                        {{ `${this.$t('new_escorter')}` }}
                    </button>
                    <button type="button" class="btn btn-success btn-with-shadow ml-2" @click="exportEscorters()"
                        v-if="this.$can('manage_export_escorters')">
                        <app-icon name="file" class="size-20 mr-2" />
                        {{ $t('excel_export') }}
                    </button>
                </div>
            </div>
        </div>

        <app-table :id="tableId" :options="options" @action="getListAction" />

        <escorter-add-edit-modal v-if="isAddEditModalActive" :table-id="tableId" :selected-url="selectedUrl"
            @close-modal="closeAddEditModal" />

        <app-delete-modal v-if="deleteConfirmationModalActive" :preloader="deleteLoader" modal-id="escorter-delete"
            @confirmed="confirmed" @cancelled="cancelled" />
    </div>
</template>

<script>

import CoreLibrary from '../../../../core/helpers/CoreLibrary';
import * as actions from "../../../Config/ApiUrl";
import { status } from '../../../Mixins/FilterMixin';
import { urlGenerator } from '../../../Helpers/AxiosHelper';
import AppFunction from '../../../../core/helpers/app/AppFunction';

export default {
    extends: CoreLibrary,
    mixins: [status],
    name: "AppEscorters",
    data() {
        return {
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: '',
            tableId: 'escorters-table',
            rowData: {},
            options: {
                name: 'AppEscorters',
                url: actions.ESCORTER,
                showHeader: true,
                // enableRowSelect: false,
                enableSaveFilter: true,
                columns: [
                    {
                        title: this.$t('ID'),
                        type: 'text',
                        key: 'id'
                    },
                    {
                        title: this.$t('escorter'),
                        type: 'custom-html',
                        modifier: (value, row) => {
                            return `${row.first_name} ${row.middle_name} ${row.last_name}`;
                        }
                    },
                    {
                        title: this.$t('matricule'),
                        type: 'custom-html',
                        key: 'matricule',
                        modifier: (value) => {
                            if (value.length > 1) {
                                return `<strong>${value}</strong>`
                            }
                            return '-'
                        }
                    },
                    {
                        title: this.$t('status'),
                        type: 'custom-html',
                        key: 'active',
                        isVisible: true,
                        modifier: (value) => {
                            if (value) {
                                return `<span class="badge badge-sm badge-pill badge-success">${this.$t('active')}</span>`;
                            } else {
                                return `<span class="badge badge-sm badge-pill badge-danger">${this.$t('inactive')}</span>`;
                            }
                        }
                    },
                    {
                        title: this.$t('city_work'),
                        type: 'text',
                        key: 'city'
                    },
                    {
                        title: this.$t('employee_category'),
                        type: 'custom-html',
                        key: 'category',
                        isVisible: true,
                        modifier: (value) => {
                            if (value) {
                                return `<a class="" href="tel:${value}">
                                    ${this.$t(value)}
                                </a>`;
                            }
                        }
                    },
                                        {
                        title: this.$t('work_phone'),
                        type: 'custom-html',
                        key: 'work_phone',
                        isVisible: true,
                        modifier: (value) => {
                            if (value) {
                                return `<a class="" href="tel:${value}">
                                    ${this.$t(value)}
                                </a>`;
                            }
                        }
                    },
                    {
                        title: this.$t('personal_phone'),
                        type: 'custom-html',
                        key: 'phone',
                        isVisible: true,
                        modifier: (value) => {
                            if (value) {
                                return `<a class="" href="tel:${value}">
                                    ${this.$t(value)}
                                </a>`;
                            }
                        }
                    },
                    
                    {
                        title: this.$t('actions'),
                        type: 'action'
                    }
                ],
                filters: [
                    {
                        "title": this.$t('employee_category'),
                        "type": "multi-select-filter",
                        "key": "category",
                        "option": [
                            { id: 'team_leader', name: this.$t('team_leader') },
                            { id: 'commander', name: this.$t('commander') },
                            { id: 'supervisor', name: this.$t('supervisor') },
                            { id: 'checkpoint', name: this.$t('checkpoint') },
                            { id: 'transporter', name: this.$t('transporter') },
                            { id: 'loader', name: this.$t('loader') },
                            { id: 'guard', name: this.$t('guard') },
                            { id: 'control', name: this.$t('control') },
                        ],
                        listValueField: 'name'
                    },
                    {
                        "title": this.$t('city_work'),
                        "type": "multi-select-filter",
                        "key": "city",
                        "option": [
                            { id: 'kolwezi', name: 'Kolwezi' },
                            { id: 'likasi', name: 'Likasi' },
                            { id: 'lubumbashi', name: 'Lubumbashi' },
                            { id: 'kasumbalesa', name: 'Kasumbalesa' },
                            { id: 'mokambo', name: 'Mokambo' },
                            { id: 'sakania', name: 'Sakania' },
                            { id: 'ndola', name: 'Ndola' },
                        ],
                        listValueField: 'name'
                    },
                    {
                        "title": this.$t('work_phone'),
                        "type": "radio",
                        "key": "work_phone",
                        "header": {
                            "title": "Voulez-vous filtrer votre liste ?",
                            "description": "Vous pouvez filtrer votre tableau de données créé en fonction du segment."
                        },
                        "option": [
                            {
                                id: 1,
                                name: "Agents ayant un numéro de service"
                            },
                            {
                                id: 2,
                                name: "Agents sans numéro de service"
                            }
                        ],
                        listValueField: 'name'
                    },
                    {
                        "title": this.$t('status'),
                        "type": "radio",
                        "key": "active",
                        "header": {
                            "title": "Voulez-vous filtrer votre liste ?",
                            "description": "Vous pouvez filtrer votre tableau de données créé en fonction du segment."
                        },
                        "option": [
                            {
                                id: 1,
                                name: "Agents Actifs"
                            },
                            {
                                id: 2,
                                name: "Agents Inactifs"
                            }
                        ],
                        listValueField: 'name'
                    },
                ],
                actions: [
                    {
                        title: this.$t('details'),
                        icon: 'eye',
                        type: 'none',
                        component: 'escorter-add-modal',
                        modalId: 'escorter-add-edit-Modal',
                        modifier: () => this.$can('update_escorters'),

                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash',
                        type: 'none',
                        component: 'app-confirmation-modal',
                        modalId: 'user-delete',
                        modifier: () => this.$can('delete_escorters'),
                    }
                ],
                showSearch: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                // cardViewComponent: 'trip-add-edit-modal',
                rowLimit: 8,
                showAction: true,
                orderBy: 'desc',
                actionType: "default",
            }
        }
    },
    created() {
    },
    methods: {
        exportEscorters() {
            const searchParams = window.location.search;
            window.open(AppFunction.getAppUrl(`export-escorters${searchParams}`));
        },
        /**
         * for open add edit modal
         */
        openAddEditModal() {
            this.isAddEditModalActive = true;
        },

        /**
         * for close add edit modal
         */
        closeAddEditModal() {
            $("#escorter-add-edit-modal").modal('hide');
            this.isAddEditModalActive = false;
            this.reSetData();
        },

        /**
         * $emit Form datatable action
         */
        getListAction(rowData, actionObj) {
            this.rowData = rowData;
            this.escorterId = rowData.id;
            
            if (actionObj.title == 'Delete') {
                this.openDeleteModal();
            } else if (actionObj.title == this.$t('edit')) {
                this.selectedUrl = `${actions.ESCORTER}/${rowData.id}`;
                this.openAddEditModal();
            } else if (actionObj.title == this.$t('details')) {
                window.location = urlGenerator(`escorters/${this.escorterId}/details`);
            }
        },

        /**
         * for open confirmation modal
         */
        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        /**
         * confirmed $emit Form confirmation modal
         */
        confirmed() {
            let url = `${actions.ESCORTER}/${this.rowData.id}`;
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then(response => {
                    this.deleteLoader = false;
                    $("#escorter-delete").modal('hide');
                    this.cancelled();
                    this.$toastr.s(response.data.message);
                }).catch(({ error }) => {
                    // Trigger after error
                }).finally(() => {
                    this.$hub.$emit('reload-' + this.tableId);
                });
        },

        /**
         * cancelled $emit Form confirmation modal
         */
        cancelled() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },
        reSetData() {
            this.rowData = {};
            this.selectedUrl = '';
        },
    },
}
</script>
